export enum ClassroomState {
    ASSIGNING = 'assigning',
    LESSONING = 'lessoning',
    ENDED = 'ended',
}

export function isRoomState(state: unknown): state is ClassroomState {
    return state === ClassroomState.ASSIGNING || state === ClassroomState.LESSONING || state === ClassroomState.ENDED;
}

export interface ClassroomSettings {
    page: number;
    screenSharing: boolean;
    writingHints: boolean;
    freeStyleMode: boolean;
    screenSync: boolean;
}

export function isClassroomSettings(settings: unknown): settings is ClassroomSettings {
    return (
        typeof (settings as ClassroomSettings).page === 'number' &&
        typeof (settings as ClassroomSettings).screenSharing === 'boolean' &&
        typeof (settings as ClassroomSettings).writingHints === 'boolean' &&
        typeof (settings as ClassroomSettings).freeStyleMode === 'boolean' &&
        typeof (settings as ClassroomSettings).screenSync === 'boolean'
    );
}

export type UserRole = 'teacher' | 'student' | null;

export interface ClientLabel {
    isGuest: boolean;
    studentProfileId: string;
    studentName: string;
    studentNumber: string;
    profilePicURL: string;
    clientNumber: number;
    role: UserRole;
    socketId: string;
    deviceLabel: string;
}

export function isClientLabel(label: unknown): label is ClientLabel {
    return (
        typeof (label as ClientLabel).studentProfileId === 'string' &&
        typeof (label as ClientLabel).studentName === 'string' &&
        typeof (label as ClientLabel).studentNumber === 'string' &&
        typeof ((label as ClientLabel).profilePicURL === 'string' || (label as ClientLabel).profilePicURL === null) &&
        typeof (label as ClientLabel).clientNumber === 'number' &&
        (typeof (label as ClientLabel).role === 'string' || (label as ClientLabel).role === null) &&
        typeof (label as ClientLabel).socketId === 'string' &&
        typeof (label as ClientLabel).deviceLabel === 'string'
    );
}
